import React from 'react';
const stats: [string, string][] = [['6', 'Tomes Premium Illustrés'], ['300+', 'Pages de Contenu'], ['84', 'Cartes de Phrases de Guérison'], ['11', 'Guides Complets'], ['5', 'Bonus Cliniques Offerts']];
export function StatsBar() {
  return <section className="w-full bg-surface px-4 py-10 sm:py-12" data-id="element-214" data-mp="1odhxt3nc7x1t">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 text-center sm:grid-cols-3 lg:grid-cols-5" data-id="element-215" data-mp="1jbisvpby8s2r">
        {stats.map(([value, label]) => <div key={label} data-id="element-216" data-mp="19mitw5xg5wok">
            <div className="font-serif text-4xl text-amber" data-id="element-217" data-mp="19m8z851gj1cj">{value}</div>
            <div className="mx-auto mt-1 max-w-[11rem] text-[10px] font-bold uppercase tracking-[0.13em] text-navy/70 sm:text-xs" data-id="element-218" data-mp="15kntd3ncbnbu">
              {label}
            </div>
          </div>)}
      </div>
    </section>;
}